import { render, staticRenderFns } from "./CcrComplianceFund.vue?vue&type=template&id=37a6e383&"
import script from "./CcrComplianceFund.vue?vue&type=script&lang=js&"
export * from "./CcrComplianceFund.vue?vue&type=script&lang=js&"
import style0 from "./CcrComplianceFund.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports